// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SimpleIntakeRequestModel {
    static getAttributeTypeMap() {
        return SimpleIntakeRequestModel.attributeTypeMap;
    }
}
SimpleIntakeRequestModel.discriminator = undefined;
SimpleIntakeRequestModel.additionalProperties = false;
SimpleIntakeRequestModel.attributeTypeMap = [
    {
        "name": "assignmentOfBenefits",
        "baseName": "assignmentOfBenefits",
        "type": "boolean"
    },
    {
        "name": "autoReenroll",
        "baseName": "autoReenroll",
        "type": "boolean"
    },
    {
        "name": "contacts",
        "baseName": "contacts",
        "type": ""
    },
    {
        "name": "diagnosis",
        "baseName": "diagnosis",
        "type": "SimpleIntakeDiagnosisModel"
    },
    {
        "name": "patient",
        "baseName": "patient",
        "type": "SimpleIntakePatientModel"
    },
    {
        "name": "payors",
        "baseName": "payors",
        "type": "SimpleIntakePayorsModel"
    },
    {
        "name": "pharmacies",
        "baseName": "pharmacies",
        "type": ""
    },
    {
        "name": "prescribers",
        "baseName": "prescribers",
        "type": ""
    },
    {
        "name": "prescriptions",
        "baseName": "prescriptions",
        "type": ""
    },
    {
        "name": "sites",
        "baseName": "sites",
        "type": ""
    },
    {
        "name": "sourceId",
        "baseName": "sourceId",
        "type": "number"
    },
    {
        "name": "surveys",
        "baseName": "surveys",
        "type": ""
    },
    {
        "name": "thirdPartyId",
        "baseName": "thirdPartyId",
        "type": "string"
    },
    {
        "name": "workflows",
        "baseName": "workflows",
        "type": ""
    },
];
//# sourceMappingURL=simpleIntakeRequestModel.js.map